import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === 'production') {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // In development, avoid StrictMode to reduce double-invocation noise/timeouts
  root.render(<App />);
}

// Registro del Service Worker para PWA y notificaciones
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registrado exitosamente:', registration);
        
        // Verificar si hay actualizaciones
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('🔄 Nueva versión del Service Worker disponible');
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('📦 Nueva versión lista. Recarga la página para aplicar cambios.');
              
              // Opcional: Mostrar notificación al usuario sobre la actualización
              if (window.confirm('Hay una nueva versión disponible. ¿Deseas actualizar?')) {
                try {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                } catch (err) {
                  // En iframes o contextos restringidos postMessage puede fallar (MessageNotSentError)
                  console.warn('No se pudo notificar al Service Worker:', err?.message || err);
                }
                window.location.reload();
              }
            }
          });
        });
        
        // Escuchar cuando el Service Worker tome control
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('🔄 Service Worker actualizado');
          window.location.reload();
        });
        
      })
      .catch((registrationError) => {
        console.log('❌ Error al registrar Service Worker:', registrationError);
      });
  });
}

// Solicitar permisos para notificaciones push al cargar la aplicación
window.addEventListener('load', () => {
  // Solo solicitar si estamos en el admin
  if (window.location.pathname.includes('/admin')) {
    requestNotificationPermissions();
  }
});

// Función para solicitar permisos de notificación
async function requestNotificationPermissions() {
  if ('Notification' in window && 'serviceWorker' in navigator) {
    try {
      const permission = await Notification.requestPermission();
      console.log('🔔 Permisos de notificación:', permission);
      
      if (permission === 'granted') {
        console.log('✅ Notificaciones habilitadas');
        
        // Opcional: Suscribirse a notificaciones push
        // await subscribeToNotifications();
      } else {
        console.log('⚠️ Notificaciones denegadas o no disponibles');
      }
    } catch (error) {
      console.log('❌ Error solicitando permisos de notificación:', error);
    }
  }
}


// Detectar si la app está instalada como PWA
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('💾 PWA instalable detectada');
  
  // Prevenir que Chrome 67 y anteriores muestren automáticamente el prompt
  e.preventDefault();
  
  // Guardar el evento para mostrarlo más tarde
  window.deferredPrompt = e;
  
  // Opcional: Mostrar tu propio botón de instalación
  // showInstallButton();
});

// Detectar cuando la PWA es instalada
window.addEventListener('appinstalled', (evt) => {
  console.log('🎉 PWA instalada exitosamente');
  
  // Opcional: Analytics o acciones post-instalación
  // trackInstallation();
});

// Función para mostrar el prompt de instalación (para usar en un botón)
window.showInstallPrompt = async () => {
  if (window.deferredPrompt) {
    window.deferredPrompt.prompt();
    
    const { outcome } = await window.deferredPrompt.userChoice;
    console.log(`💾 Resultado de instalación: ${outcome}`);
    
    window.deferredPrompt = null;
  }
};

// Detectar si está corriendo como PWA
if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
  console.log('📱 Ejecutándose como PWA');
} else {
  console.log('🌐 Ejecutándose en navegador');
}

// Capturar rechazos no manejados para evitar errores genéricos
window.addEventListener('unhandledrejection', (e) => {
  const reason = e && (e.reason?.message || e.reason) || '';
  const reasonStr = typeof reason === 'string' ? reason : String(reason);
  // Suprimir errores conocidos de Firebase/SW que no afectan la app
  if (/RegisterClientLocalizationsError|MessageNotSentError/i.test(reasonStr)) {
    e.preventDefault();
    if (process.env.NODE_ENV === 'development') {
      console.warn('Rechazo suprimido (conocido):', reasonStr);
    }
    return;
  }
  e.preventDefault();
  console.error('Unhandled rejection:', reasonStr || 'unknown');
});